<template>
  <div>
    <video
      ref="video"
      class="promise__video u-fit-cover u-wrapper-panel"
      :src="videoSRC"
      autoplay
      preload="auto"
      muted
      :class="{'is-visible': !isInverse}"
    />
    <video
      ref="videoInverse"
      class="promise__video u-fit-cover u-wrapper-panel"
      :src="videoInverseSRC"
      autoplay
      preload="auto"
      muted
      :class="{'is-visible': isInverse}"
    />
  </div>
</template>

<script>
import { VirtualScroll } from '@/utils/VirtualScroll'
import { clamp, mapper } from '@/utils/Maths'

// const factor = .001
const factor = 1000

export default {
  props: {
    videoSRC: {
      type: String,
      required: true
    },
    videoInverseSRC: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isInverse: false
    }
  },

  mounted () {
    this.duration = 0
    this.currentTime = 0
    this.isEnding = false
    this.video = this.$refs.video
    this.videoInverse = this.$refs.videoInverse
    this.video.playbackRate = 0
    this.videoInverse.playbackRate = 0
    this.video.play()
    this.videoInverse.play()
    this.video.addEventListener('loadedmetadata', this.onVideoData)
  },

  beforeDestroy () {
    if (!this.$device.isMobile) {
      this.virtualScroll.onDestroy()
    }
  },

  methods: {
    onVideoData () {
      this.duration = this.$refs.video.duration

      this.$emit('ready', true)

      if (!this.$device.isMobile) {
        const max = this.duration * factor
        this.virtualScroll = new VirtualScroll({
          clamp: {
            min: -max,
            max: max
          },
          smooth: .12
        })
      
        this.virtualScroll.onSmoothScroll(this.onSmoothScroll)
      }
      else {
        this.video.playbackRate = 1
      }
    },

    onUpdate () {
      if (this.duration !== 0 && this.$device.isMobile && this.$refs.video.currentTime > this.duration - 1 && !this.isEnding) {
        this.$emit('ending', true)
        this.isEnding = true
      }
    },

    onSmoothScroll ({ delta, progress }) {
      this.currentTime = this.$refs.video.currentTime

      let playbackRate = mapper(delta, 5.5, -5.5, -1, 1)
      playbackRate = clamp(playbackRate, -10, 10)

      if (playbackRate < 0) {
        this.video.playbackRate = 0
        this.videoInverse.playbackRate = -Math.round(playbackRate * 10) * .1
        this.isInverse = true
      }
      else {
        this.video.playbackRate = Math.round(playbackRate * 10) * .1
        this.videoInverse.playbackRate = 0
        this.isInverse = false
      }
      
      if(progress > .58 && !this.isEnding) {
        this.$emit('ending', true)
        this.isEnding = true
      }


      if(progress < .58 && this.isEnding) {
        this.$emit('ending', false)
        this.isEnding = false
      }
    }
  },
  watch: {
    isInverse (to) {
      if (to) {
        this.videoInverse.currentTime =  this.duration - this.video.currentTime
      }
      else {
        this.video.currentTime = this.duration - this.videoInverse.currentTime
      }
    }
  }
}
</script>

<style lang="stylus">
.promise__video
  opacity 0
  transition opacity .1s .2s linear
  
  &.is-visible
    opacity 1
    transition opacity .1s .1s linear
    
</style>
 